import * as React from 'react';
import { LiveClassCohort, LiveClassSession } from '@magoosh/admin/live_class_sessions/types';
import { useState } from 'react';
import fetch from 'utilities/fetch';
import { adminPaths } from 'config/path_helpers';
import { DefaultButton } from '@magoosh/lib/button';

interface BulkRegistrationResult {
  classSession: LiveClassSession;
  registered: RegisteredUser[];
  alreadyRegistered: RegisteredUser[];
  error: RegisteredUser[];
}

interface RegisteredUser {
  id: number;
  descriptor: string;
  error?: string;
}

const blankResults: BulkRegistrationResult[] = [];

const BulkCohortRegistration: React.FC<LiveClassCohort> = (cohort) => {
  const [results, setResults] = useState(blankResults);
  const [registering, setRegistering] = useState(false);

  const onClickBulkRegistration = () => {
    setRegistering(true);
    fetch(adminPaths.api.liveClassBulkRegistration(cohort.id), { method: 'POST' })
      .then((response) => {
        setResults(response.results);
      })
      .catch((error) => alert(error))
      .finally(() => setRegistering(false));
  };

  return (
    <div>
      <div>
        <p>
          Click to automatically register all active students in this cohort for all class sessions that have
          been synced to Magoosh.
        </p>
        <DefaultButton onClick={onClickBulkRegistration} submitting={registering} icon="calendar-check-o">
          Register
        </DefaultButton>
      </div>

      <div>
        {results.map((result) => (
          <div key={result.classSession.id}>
            <h4>{result.classSession.name}</h4>
            <p>Successfully registered: {result.registered.length}</p>
            <p>Already registered: {result.alreadyRegistered.length}</p>
            <div>
              <p>Failed: {result.error.length}</p>
              <ul>
                {result.error.map((user) => (
                  <li key={user.id}>
                    <a href={adminPaths.user(user.id)}>{user.descriptor}</a>: {user.error}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BulkCohortRegistration;
